export enum MaterialTypes {
    INPUT = 'input',
    OUTPUT = 'output',
    INTERMEDIATE = 'intermediate',
    MSSMATERIAL = 'material'
}
